var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListIconSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 0V16H12.9962V0H3ZM12.5059 15.5098H11.2827C11.7852 15.2105 12.2067 14.789 12.5059 14.2865V15.5098ZM9.74412 15.4998V12.7479H12.496C12.3775 14.211 11.2072 15.3813 9.74412 15.4998ZM12.5059 1.75109H12.2507V2.24134H12.5059V12.2577H9.25391V15.5098H3.49022V2.24134H3.74541V1.75109H3.49022V0.49025H12.5059V1.75109Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.74641 1.75H4.24609V2.24025H4.74641V1.75Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.74641 1.75H5.24609V2.24025H5.74641V1.75Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.74641 1.75H6.24609V2.24025H6.74641V1.75Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74641 1.75H7.24609V2.24025H7.74641V1.75Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75031 1.75H8.25V2.24025H8.75031V1.75Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75031 1.75H9.25V2.24025H9.75031V1.75Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7503 1.75H10.25V2.24025H10.7503V1.75Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7503 1.75H11.25V2.24025H11.7503V1.75Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7508 3.75391H4.24609V4.24416H11.7508V3.75391Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7508 5.00391H4.24609V5.49416H11.7508V5.00391Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7508 6.25391H4.24609V6.74416H11.7508V6.25391Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7508 7.50391H4.24609V7.99416H11.7508V7.50391Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7508 8.75391H4.24609V9.24416H11.7508V8.75391Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7508 10.0078H4.24609V10.4981H11.7508V10.0078Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7508 11.2578H4.24609V11.7481H11.7508V11.2578Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99919 12.5078H4.24609V12.9981H8.99919V12.5078Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99919 13.7578H4.24609V14.2481H8.99919V13.7578Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListIconSvg);
export default __webpack_public_path__ + "static/media/list-icon-svg.3f2a01addf3708b6223165a4f3d7d624.svg";
export { ForwardRef as ReactComponent };